define(
    'viewmodels/secured/explorer/details/tabs/actions/actions',[
        "viewmodels/secured/explorer/context",
        "viewmodels/ViewModel",        
        "viewmodels/secured/explorer/details/details",
        "viewmodels/secured/explorer/details/tabs/actions/ActionGroup",
        "viewmodels/secured/explorer/details/tabs/actions/ActionProvider",
        "i19n!i19n/strings",
        "viewmodels/secured/explorer/details/tabs/actions/actionsShare/actionsShare"
    ],
    function (ctx, ViewModel, details, ActionGroup, ActionProvider, i19n, modelShare) {

        var actionProvider = new ActionProvider(details);

        var vm = new ViewModel(
        {
            selectedActionGroup: ko.observable(),
            i19n: i19n,
            isGuest: ko.observable(false),
            isVersionFeature: ko.observable(false),
            mode: ko.observable('action'),
            modelShare: ko.observable(modelShare)
        });

        vm.actionGroups = buildActions();        
        
        ctx.onNavSearch.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });
        ctx.onNavFavoriteFolder.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });
        ctx.onNavFavoriteSearch.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });
        ctx.onNavFavoriteDocument.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });
        ctx.onNavFlagged.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });
        ctx.onNavRecent.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });        
        ctx.onNavMyCheckedOut.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.checkout);
        });
        ctx.onNavAllCheckedOut.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.checkoutAll);
        });
        ctx.onNavFolder.subscribe(function (data) {
            vm.selectedActionGroup(vm.actionGroups.common);
        });
        ctx.onNavFolderShowDeleted.subscribe(function (data) {
            vm.actionGroups.delete.isShowingAllDocuments(false);
            vm.selectedActionGroup(vm.actionGroups.delete);
        });
        ctx.onNavMyDeleted.subscribe(function (data) {
            vm.actionGroups.delete.isShowingAllDocuments(false);
            vm.selectedActionGroup(vm.actionGroups.delete);
        });
        ctx.onNavAllDeleted.subscribe(function (data) {
            vm.actionGroups.delete.isShowingAllDocuments(true);
            vm.selectedActionGroup(vm.actionGroups.delete);
        });
        
        vm.modelShare().onCancel(function () {
            vm.mode("action");
            
            initShareMenu();
        });

        vm.activate = function (d) {
            vm.mode("action");
            
            //vm.isVersionFeature(vm.session.user().emailAddress().indexOf('@radix.com.au') != -1 || vm.session.user().emailAddress().indexOf('rollie') != -1);
            vm.isVersionFeature(true);
            
            vm.isGuest(d);
        };
         
        vm.attached = function () {
            initShareMenu();
        };

        return vm;

        function initShareMenu() {
            $("#module-share").hide();
            
            $("#share-li").off("click", "**");
            $("#share-li").on("click", function (e) {
                var h = 163;

                if ($("#share-li").height() != h) {
                    $("#share-li").height(h);
                    $("#share-li").addClass("current");

                    //$("#share-li-sub").show();
                    $("#share-li-sub").slideDown("200", function () { });

                    vm.mode('action');
                } else {
                    $("#share-li").height(18);
                    $("#share-li").removeClass("current");

                    //$("#share-li-sub").hide();
                    $("#share-li-sub").slideUp("200", function () { });
                }

                e.preventDefault();

                return false;
            });
            $("#share-li-sub").off("click", "**");
            $("#share-li-sub").on("click", function (e) {
                $("#share-li").removeClass("current");

                //if (!vm.isVersionFeature()) {
                //    if ($(e.target).text().trim() == 'Email as Attachment' || $(e.target).text().trim() == 'Email as Link') {
                //        toastr.success("Feature coming soon!");
                //    }
                //}

                if ($(e.target).text().trim() == 'Email as Link') {
                    $("#share-li-sub").hide();
                }
                if ($(e.target).text().trim() == 'Email as Attachment') {
                    $("#share-li-sub").hide();
                }

                if ($(e.target).text().trim() == 'Email as Document Share') {
                    $("#share-li-sub").hide();

                    vm.mode('share');
                    
                    $("#module-share").show();
                }
            });

            $("#share-li-sub").hide();
        }

        function buildActions() {
            var actionGroups = {
                common: null,
                checkout: null,
                checkoutAll: null,
                delete: null,
                bulkDownload: null,
                emailAs: null
            };

            //#region Hide/Disable Filters

            var ifNotMultipleSelected = ko.computed(function () {
                return details.checkedDocuments().length > 1;
            });
            var ifNotDeleteMode = ko.computed(function () {                
                var selected = vm.selectedActionGroup();
                
                return vm.actionGroups != null && selected == actionGroups.delete;
            });
            var ifDeleteMode = ko.computed(function () {
                var selected = vm.selectedActionGroup();

                return vm.actionGroups != null && selected != actionGroups.delete;
            });
            var ifNotCheckoutMode = ko.computed(function () {
                var selected = vm.selectedActionGroup();

                return vm.actionGroups != null && selected == actionGroups.checkout;
            });
            var ifCheckoutAllMode = ko.computed(function () {
                var selected = vm.selectedActionGroup();

                return vm.actionGroups != null && selected != actionGroups.checkoutAll;
            });
            var ifNotCheckoutAllMode = ko.computed(function () {
                var selected = vm.selectedActionGroup();

                return vm.actionGroups != null && selected == actionGroups.checkoutAll;
            });

            //#endregion
            
            actionGroups.common = new ActionGroup([ifNotDeleteMode, ifNotCheckoutAllMode]);
            actionGroups.common.actions.push(
                actionProvider.ShareAction(),                
                actionProvider.DocumentLinksAction(),
                //actionProvider.SaveNewVersionAction([ifNotMultipleSelected]),
                actionProvider.ExportDocumentsAction(),
                actionProvider.CopyDocumentsAction(),
                actionProvider.MoveDocumentsAction(),
                actionProvider.BulkDownloadAction(),
                actionProvider.ReplaceFileAction([ifNotMultipleSelected]),
                actionProvider.ModifyFieldAction()
            );                        

            actionGroups.emailAs = new ActionGroup([ifNotDeleteMode, ifNotCheckoutAllMode]);
            actionGroups.emailAs.actions.push(actionProvider.EmailAsLinkAction());
            actionGroups.emailAs.actions.push(actionProvider.EmailAsAttachmentAction());
            actionGroups.emailAs.actions.push(actionProvider.EmailAsShareAction());

            actionGroups.bulkDownload = new ActionGroup([ifNotDeleteMode, ifNotCheckoutAllMode]);
            actionGroups.bulkDownload.actions.push(actionProvider.BulkDownloadAction());

            actionGroups.checkout = new ActionGroup([ifNotDeleteMode]);
            actionGroups.checkout.actions.push(
                actionProvider.CheckoutAction([ifNotCheckoutMode], [ifNotCheckoutAllMode]),
                actionProvider.CheckinAction([ifNotMultipleSelected]),
                actionProvider.CancelCheckoutAction()
            );

            actionGroups.delete = new ActionGroup([ifNotCheckoutAllMode]);
            actionGroups.delete.isShowingAllDocuments = ko.observable(false);
            actionGroups.delete.actions.push(
                actionProvider.DeleteAction([], [ifNotDeleteMode]),
                actionProvider.UndeleteAction([], [ifDeleteMode]),
                actionProvider.PurgeDeletedAction([], [ifDeleteMode])
            );

            return actionGroups;
        }
    });
